import { normalizeText } from '@vif/core';
/**
 * PRD §8.4 Tier A steps 2–3: paragraph joining via indent / short-line /
 * vertical-gap heuristics + hasEOL, and dehyphenation (line ends '-', next
 * line starts lowercase → merge). Page boundaries are NOT paragraph breaks:
 * a paragraph (or hyphenated word) flows across pages unless a join trigger
 * fires. PDF blocks are always paragraphs — heading detection is Tier B.
 */
/** New paragraph when the vertical gap exceeds this multiple of the leading. */
const GAP_LEADING_FACTOR = 1.8;
/** First-line indent beyond this multiple of the line height starts a paragraph. */
const INDENT_HEIGHT_FACTOR = 0.8;
const INDENT_MIN = 4;
/** A line under this fraction of the median width closes its paragraph. */
const SHORT_LINE_FRACTION = 0.7;
const TRAILING_HYPHEN = /[-‐]$/;
const STARTS_LOWERCASE = /^\p{Ll}/u;
function median(values) {
    if (values.length === 0)
        return 0;
    const sorted = [...values].sort((a, b) => a - b);
    return sorted[Math.floor(sorted.length / 2)];
}
/** Most common rounded left edge = the body's left margin. */
function modalX0(lines) {
    const counts = new Map();
    for (const line of lines) {
        const key = Math.round(line.x0);
        counts.set(key, (counts.get(key) ?? 0) + 1);
    }
    let best = 0;
    let bestCount = -1;
    for (const [key, count] of counts) {
        if (count > bestCount) {
            best = key;
            bestCount = count;
        }
    }
    return best;
}
export function linesToBlocks(lines) {
    if (lines.length === 0)
        return [];
    const gaps = [];
    for (let i = 1; i < lines.length; i++) {
        const prev = lines[i - 1];
        const line = lines[i];
        if (line.page === prev.page && prev.y > line.y)
            gaps.push(prev.y - line.y);
    }
    const leading = median(gaps);
    const bodyX0 = modalX0(lines);
    const medianWidth = median(lines.map((line) => line.x1 - line.x0));
    const blocks = [];
    let paragraph = '';
    const flush = () => {
        const text = normalizeText(paragraph.replace(/\s+/g, ' ').trim());
        paragraph = '';
        if (text.length > 0)
            blocks.push({ kind: 'paragraph', text });
    };
    let prev;
    for (const line of lines) {
        if (prev !== undefined && startsNewParagraph(prev, line, leading, bodyX0, medianWidth)) {
            flush();
        }
        if (paragraph.length === 0) {
            paragraph = line.text;
        }
        else if (TRAILING_HYPHEN.test(paragraph) && STARTS_LOWERCASE.test(line.text)) {
            paragraph = paragraph.slice(0, -1) + line.text;
        }
        else {
            paragraph += ' ' + line.text;
        }
        prev = line;
    }
    flush();
    return blocks;
}
function startsNewParagraph(prev, line, leading, bodyX0, medianWidth) {
    if (line.hardBreakBefore)
        return true;
    if (line.page === prev.page && leading > 0 && prev.y - line.y > GAP_LEADING_FACTOR * leading) {
        return true;
    }
    if (line.x0 - bodyX0 > Math.max(INDENT_MIN, INDENT_HEIGHT_FACTOR * line.height))
        return true;
    if (medianWidth > 0 && prev.x1 - prev.x0 < SHORT_LINE_FRACTION * medianWidth)
        return true;
    return false;
}
//# sourceMappingURL=paragraphs.js.map